import { render, staticRenderFns } from "./OptionGroup.vue?vue&type=template&id=3bc86875&scoped=true"
import script from "./OptionGroup.vue?vue&type=script&lang=js"
export * from "./OptionGroup.vue?vue&type=script&lang=js"
import style0 from "./OptionGroup.vue?vue&type=style&index=0&id=3bc86875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc86875",
  null
  
)

export default component.exports